export default __webpack_public_path__ + "static/media/FMS-500-One.1ba8e6be.png";